/**
 * Tab Análise de origem — mostra a análise que gerou o projeto.
 */

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { analisesAPI } from '../../../services/inovacaoAPI';

export default function AnaliseOrigem({ projeto }) {
  const [analise, setAnalise] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    analisesAPI.obter(projeto.analise_id)
      .then(setAnalise)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [projeto.analise_id]);

  if (loading) return <div style={cardStyle}>Carregando…</div>;
  if (!analise) return <div style={cardStyle}>Análise de origem não encontrada.</div>;

  return (
    <div style={cardStyle}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div>
          <h3 style={{ margin: 0, color: '#2c3e50' }}>{analise.titulo}</h3>
          <div style={{ color: '#7f8c8d', fontSize: '0.85rem', marginTop: 4 }}>
            Solicitado por <b>{analise.responsavel_respostas?.nome}</b>
            &nbsp;·&nbsp;Setor <b>{analise.setor_solicitante?.nome}</b>
            &nbsp;·&nbsp;Executor <b>{analise.executor_gni?.nome}</b>
          </div>
        </div>
        <Link to={`/inovacao/analises/${analise.id}`}
              style={{ color: 'var(--brand, #20a490)', fontSize: '0.85rem' }}>
          Ver análise completa →
        </Link>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16, margin: '20px 0',
                    padding: 16, background: '#f8f9fa', borderRadius: 8 }}>
        <KV label="Score de oportunidade" value={analise.score_oportunidade ?? '—'} />
        <KV label="Horas mensais estimadas" value={analise.horas_mensais_estimadas_economia ?? '—'} />
        <KV label="Submetida em"
            value={analise.data_submissao ? new Date(analise.data_submissao).toLocaleDateString('pt-BR') : '—'} />
      </div>

      {analise.resumo_executivo && (
        <>
          <h4 style={h4Style}>Resumo executivo</h4>
          <p style={pStyle}>{analise.resumo_executivo}</p>
        </>
      )}
      {analise.objetivo && (
        <>
          <h4 style={h4Style}>Objetivo</h4>
          <p style={pStyle}>{analise.objetivo}</p>
        </>
      )}
      {analise.setores_impactados?.length > 0 && (
        <>
          <h4 style={h4Style}>Setores impactados</h4>
          <p style={pStyle}>{analise.setores_impactados.map((s) => s.nome).join(' · ')}</p>
        </>
      )}
    </div>
  );
}

function KV({ label, value }) {
  return (
    <div>
      <div style={{ fontSize: '0.72rem', color: '#95a5a6', textTransform: 'uppercase',
                    letterSpacing: 0.5 }}>{label}</div>
      <div style={{ fontSize: '1.1rem', fontWeight: 600, color: '#2c3e50', marginTop: 2 }}>{value}</div>
    </div>
  );
}

const cardStyle = { background: '#fff', borderRadius: 12, padding: 24,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)' };
const h4Style = { margin: '20px 0 8px', color: '#2c3e50', fontSize: '0.85rem',
                  textTransform: 'uppercase', letterSpacing: 0.5 };
const pStyle = { margin: 0, color: '#555', lineHeight: 1.6, whiteSpace: 'pre-wrap' };
